import {
  Award,
  BookOpen,
  Bookmark,
  Calendar,
  Dumbbell,
  Flag,
  Flame,
  GraduationCap,
  Link,
  Palette,
  PartyPopper,
  Tag,
  Trophy,
  Zap,
} from 'lucide-react';
import type { ComponentType } from 'react';

type BadgeIconComponent = ComponentType<{ className?: string }>;

/**
 * Map badge ids (from shared badge definitions) to Lucide icons.
 * Badge data keeps its emoji `icon` field for schema compatibility;
 * the UI renders these components instead.
 */
const BADGE_ICONS: Record<string, BadgeIconComponent> = {
  visual_thinker: Palette,
  first_page: BookOpen,
  book_worm: Bookmark,
  speed_reader: Zap,
  book_finished: Flag,
  first_lesson: GraduationCap,
  course_graduate: PartyPopper,
  course_master: Trophy,
  streak_3: Flame,
  streak_7: Dumbbell,
  streak_30: Calendar,
  streak_100: Award,
  sharer: Link,
  organizer: Tag,
};

export function getBadgeIcon(badgeId: string): BadgeIconComponent {
  return BADGE_ICONS[badgeId] ?? Award;
}
